// this gives us access to html5 and drop events
// DND- Drag and Drop

export default [picklistDND]

function picklistDND() {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      from: '=picklistFrom',
      ondrop: '=picklistDrop',
    },
    link: {
      post: function(scope, el, attrs) {
        el.on('dragenter dragover', (e) => {
          e.preventDefault()
          return false
        })
        el.on('drop', (e) => {
          const { from } = scope
          const to = parseInt(e.currentTarget.getAttribute('data-index'), 10)
          scope.ondrop(from, to)
        })
      },
    },
  }
}
